import { render, staticRenderFns } from "./detailMsgCopy.vue?vue&type=template&id=6348f1ba&scoped=true&"
import script from "./detailMsgCopy.vue?vue&type=script&lang=js&"
export * from "./detailMsgCopy.vue?vue&type=script&lang=js&"
import style0 from "./detailMsgCopy.vue?vue&type=style&index=0&id=6348f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6348f1ba",
  null
  
)

export default component.exports